import { Component, OnInit, Input, ViewChild, TemplateRef, ContentChild, Output, EventEmitter, Renderer2, AfterViewInit } from '@angular/core';
import * as _ from 'lodash';
import { MultiSelect } from 'primeng/multiselect'
import { UntypedFormControl} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mapfre-auditlib-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

  @ContentChild('selectedItemsTemplate', { static: false }) selectedItemsTemplate: TemplateRef<any>;
  @ContentChild('itemTemplate', { static: false }) itemTemplate: TemplateRef<any>;

  _form;
  fieldTranslation;
  model;
  instance;
  isConverted: boolean = false;  
  unsubscribeForm;
  stopPropagation;
  originalForm;
  originalModel;

  @Input() defaultValue;
  @Input() field;
  @Input() label;
  @Input() icon;
  @Input() placeholder;
  @Input() disabled;
  @Input() selectionMode;
  @Input() readonly;
  @Input() appendTo;
  @Input() showToggleAll = true;
  @Input() overlayVisible = false;
  @Input() noInput = false;
  @Input() maxSelectedLabels = 3;
  @Input() skipHighlighter = false;
  @Input() virtualScroll = true;
  @Input() sectors = false;
  @Input() sort = true;
  @Input() order = 1;
  @ViewChild('simple', { static: false }) simple: MultiSelect;
  @ViewChild('multiple', { static: false }) multiple: MultiSelect;
  @Output() onChange = new EventEmitter();
  @Output() onHide = new EventEmitter();
  @Output() onClick = new EventEmitter();
  @Output() onShow = new EventEmitter();

  get form() {
    return this._form;
  }

  @Input('form')
  set form(form) {
    if (form) {
      if (form.value) {
        this.parseForm(form);
      }
      this._form = form;
      this.originalForm = form;
      this.form.valueChanges.subscribe((newValue) => {
        this.onModelChange(newValue, true);
      });

    }
  }
  _data
  @Input()
  set data(value) {
    this._data = value;
    if (this.sort) {
      this._data = this.getItemOrderedBySelection();
      this.orderOptions();  
    } 
  }

  get data() {
    return this._data;
  }

  constructor(private translateService: TranslateService, private renderer: Renderer2) {
    this.form = new UntypedFormControl(null, [])
    this.translateService.onLangChange.subscribe(res => {
      this.translateOptions();
    })
    this.translateService.onTranslationChange.subscribe(res => {
      this.translateOptions();
    })
  }

  parseForm(form) {
    if (_.isArray(form.value)) {
      _.forEach(form.value, item => {
        if (_.get(item, this.field)) {
          _.set(item, `${this.field}Translation`, this.translateService.instant(_.get(item, this.field).toString()) ? this.translateService.instant(_.get(item, this.field).toString()) : _.get(form.value, this.field).toString());
        }
        else {
          _.set(item, `${this.field}Translation`, null);
        }
      });
    }
    else {
      if (_.get(form.value, this.field)) {
        _.set(form.value, `${this.field}Translation`, this.translateService.instant(_.get(form.value, this.field).toString()) ? this.translateService.instant(_.get(form.value, this.field).toString()) : _.get(form.value, this.field).toString());
      }
      else {
        _.set(form.value, `${this.field}Translation`, null);
      }
    }
  }

  parseModel(model) {
    if (_.isArray(model)) {
      _.forEach(model, item => {
        if (_.get(item, this.field)) {
          _.set(item, `${this.field}Translation`, this.translateService.instant(_.get(item, this.field).toString()));
        }
        else {
          _.set(item, `${this.field}Translation`, null);
        }
      });
    }
    else {
      if (_.get(model, this.field)) {
        _.set(model,`${this.field}Translation`,this.translateService.instant(_.get(model, this.field).toString()));
      }
      else {
        _.set(model,`${this.field}Translation`,null);
      }
    }
  }

  stopPropagationEvent(ev) {
    ev.stopPropagation();
  }

  onPanelHide() {
    this.renderer.removeClass(document.body, 'select-open');
    if (this.overlayVisible) {
      if (this.multiple) {
        this.multiple.overlayVisible = true;
      }
      else {
        this.simple.overlayVisible = true;
      }
    }
    this._data = this.getItemOrderedBySelection();
    this.onHide.emit();
  }

  clicked(event) {
    this.onClick.emit(event);
  }

  getItemOrderedBySelection() {
    if (this.data && this.data.length >0) {
      let idProp: any = _.find(_.keysIn(_.get(this.data, '[0]')), (prop) => { return _.findIndex(prop, 'id') });
      let ids;
      if (_.isArray(this._form.value)) {
        ids = _.map(this._form.value, (user) => _.get(user, idProp));
      }
      else {
        ids = [_.get(this.form.value, idProp)];
      }
      this._data = _.orderBy(this.data, (item) => _.find(ids, (id) => id === _.get(item, idProp)));
      return this.setDataTranslations();
    }

    return this.setDataTranslations();
  }

  setDataTranslations() {
    this.fieldTranslation = `${this.field}Translation`;
    if (this.data && this.data.length >0) {
      _.forEach(this.data, item => {
        if (_.get(item, this.field)) {
          _.set(item,this.fieldTranslation,this.translateService.instant(_.get(item, this.field).toString()) ? this.translateService.instant(_.get(item, this.field).toString()) : _.get(item, this.field).toString());
        }
        else {
          _.set(item,this.fieldTranslation,null);
        }
      });
    }

    return this.data;
  }

  ngOnInit() {
    this.selectionMode = this.selectionMode || 'multiple';
    if (this.selectionMode === 'simple' && this.form) {
      this.onModelChange(this.form.value, false);
    }
    if(this.defaultValue) {
      this.form.setValue(this.defaultValue);
    }
    // this.getItemOrderedBySelection();
    // this.orderOptions();
    
  }


  onPanelShow() {
    if (this.multiple) {
      this.instance = this.multiple;
    }
    else {
      this.instance = this.simple;
    }

    if (this.readonly) {
      this.instance.disabledSelectedOptions = this.data;
      this.instance.optionDisabled = this.instance.optionLabel;
      setTimeout(() => {

        //Add layer to avoid events
        const html = '<div class="p-overlay"></div>';
        _.forEach(this.instance.overlay?.getElementsByClassName('p-multiselect-item'), it => {
          it.classList.add('position-relative');
          it.insertAdjacentHTML('afterbegin', html);
        });

        this.instance.overlay?.getElementsByClassName('p-multiselect-items')[0].classList.add('p-multiselect-disabled-items')


        _.forEach(this.instance.overlay?.getElementsByClassName('p-chckbox-box'), it => {
          it.classList.add('p-state-disabled');
          it.classList.remove('p-state-active');
          it.addEventListener('click', (event) => {
            event.stopPropagation();
          })
        });

        _.forEach(this.instance.overlay?.getElementsByClassName('p-overlay'), it => {
          it.addEventListener('click', (event) => {
            event.stopPropagation();
          })
        });

        _.forEach(this.instance.overlay?.getElementsByTagName('span'), it => it.addEventListener('click', (event) => {
          event.stopPropagation();
        }))

        _.forEach(this.instance.overlay?.getElementsByClassName('p-multiselect-item'), it => it.addEventListener('click', (event) => {
          event.stopPropagation();
        }));


      }, 0)

    }
    this.getItemOrderedBySelection(); // destinatarios fix
    const existTodos = this.checkTodos(this.form.value);
    if (this.sectors && existTodos) {
      setTimeout(() => {
        this.setSectors({ itemValue: existTodos, value: this.form.value });
      }, 10)
    }
    this.onShow.emit();
    //this.renderer.addClass(document.body, 'select-open');
  }


  optionDisabled(disabled) {
    if (disabled) {
      disabled.stopPropagation();
    }
  }

  checkTodos(form): boolean {
    if(form && form.txtName && form.txtName === 'TODOS'){
      return true
    }else{
      return false;
    }
  }

  onModelChange(newValue, isSubscribe) {
    if (newValue !== null && newValue !== undefined) {
      this.model = _.isArray(newValue) ? _.last(newValue) ? [_.last(newValue)] : newValue : [newValue];
      this.parseModel(this.model);
      this.originalModel = this.model;
      if (!isSubscribe) {
        this.form.setValue(_.head(this.model));
      }
    } else {
      this.model = null;
      if (!isSubscribe) {
        this.form.setValue(null)
      }
    }
    if (this.simple) {
      setTimeout(() => this.simple.hide()
      )
    };

  }

  onChangeHandler(event) {
    //const eventCloned: any = this.removePropertyTranslation(_.cloneDeep(event));
    const eventCloned = _.cloneDeep(event);
    this.form.markAsTouched();
    if (this.selectionMode === 'simple') {
      if (eventCloned.value.length === 0) {
        this.onChange.emit([]);
      }
      else {
        this.onChange.emit({ value: [eventCloned.itemValue], itemValue: eventCloned.itemValue });
      }
    }
    else {
      this.onChange.emit(eventCloned);
    }

    if (this.sectors) {
      this.setSectors(eventCloned);
    }

  }

  removePropertyTranslation(event) {
    if (_.isArray(event.value) && event.value.length > 0) {
      _.forEach(event.value, item => {
        delete item[this.fieldTranslation];
      })
    }
    if (event.itemValue) {
      delete event.itemValue[this.fieldTranslation];
    }

    return event;
  }

  setSectors(event) {
    const sector = event.itemValue;
    const sectors = event.value;
    //if TODOS sector is choosen block others and deselect
    if (sector && sector.txtNombre === 'TODOS' && sectors.length > 0) {
      this.form.setValue([sector]);
      const html = '<div class="p-overlay"></div>';
      _.forEach(this.instance.overlay?.getElementsByClassName('p-multiselect-item'), it => {
        let isTodos = it.ariaLabel.toUpperCase() === sector.txtNombre;
        if (!isTodos) {
          //Add layer to disabled events
          it.classList.add('position-relative');
          it.insertAdjacentHTML('afterbegin', html);
          //Add icon to disable check
          _.forEach(it?.getElementsByClassName('p-chkbox-box'), item => {
            item.classList.add('p-state-disabled');
            item.classList.remove('p-state-active');
            /*item.addEventListener('click', (event) => {
              event.stopPropagation();
            })*/
          })
        }
      });
      //Avoid event with stop propagation
      _.forEach(this.instance.overlay?.getElementsByClassName('p-overlay'), it => {
        it.addEventListener('click', (event) => {
          event.stopPropagation();
        })
      });

    }
    else if (sector && sector.txtNombre === 'TODOS' && sectors.length === 0) {
      _.forEach(this.instance.overlay?.getElementsByClassName('p-multiselect-item'), it => {
        //Add icon to disable check
        _.forEach(it?.getElementsByClassName('p-chekbox-box'), item => {
          item.classList.remove('p-state-disabled');
        })
      });

      //Avoid event with stop propagation
      /*_.forEach(this.instance.overlay.getElementsByClassName('p-overlay'), it => {
        it.removeEventListener('click', (event) => {
          console.log(event);
        });
      });*/

      let length = _.cloneDeep(this.instance.overlay?.getElementsByClassName('p-overlay').length)
      for (let index = 0; index < length; index++) {
        this.instance.overlay?.getElementsByClassName('p-overlay').item(0).remove();
      }
    }


  }

  translateOptions() {
    let refreshData = [];
    _.forEach(this.data, (d, i) => {
      d[this.fieldTranslation] = this.translateService.instant(_.get(d, this.field).toString()) ? this.translateService.instant(_.get(d, this.field).toString()) : _.get(d, this.field).toString();
      refreshData.push(d);
    })
    this.data = refreshData;

    this.parseForm(this._form);
  }

  orderOptions() {
    if(this.field === "jobStandardName"){
      this._data = this.order === 1 ? _.reverse(_.sortBy(this._data, this.fieldTranslation)) : _.reverse(_.sortBy(this.data, this.fieldTranslation));
    }else{
      this._data = this.order === 1 ? _.sortBy(this._data, this.fieldTranslation) : _.reverse(_.sortBy(this.data, this.fieldTranslation));
    }   
  }

}